import type { DraggableAttributes } from "@dnd-kit/core";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { FoodsIcon } from "@foodpilot/foods";
import { Box } from "@mui/material";

type SortableDragHandleProps = {
    attributes: DraggableAttributes;
    listeners: SyntheticListenerMap | undefined;
    disabled: boolean;
    isDragging: boolean;
    label?: string;
};

export const SortableDragHandle = (props: SortableDragHandleProps) => {
    const { attributes, listeners, disabled, isDragging, label } = props;

    return (
        <Box
            component="button"
            type="button"
            aria-label={label}
            disabled={disabled}
            {...attributes}
            {...listeners}
            sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                p: 0,
                color: "inherit",
                background: "none",
                border: 0,
                cursor:
                    disabled ? "default"
                    : isDragging ? "grabbing"
                    : "grab",
                touchAction: "none",
            }}
        >
            <FoodsIcon size={2} icon="drag" />
        </Box>
    );
};
